/* KyDeco PDP "More from [brand]" row. Pulls same-vendor products from
   predictive search (tiny payload, whole catalog) and renders cards.
   Row stays hidden unless at least 2 available products come back. */
/* Same classifier as snippets/kd-category.liquid: whole-word keyword match
   (plural s allowed) on a lowercased, punctuation-stripped title; outdoor first. */
function classify(title, rules) {
  const t = ' ' + String(title || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  const has = (k) => t.includes(' ' + k + ' ') || t.includes(' ' + k + 's ');
  if (has('fire pit') || has('firepit') || has('fire table')) return 'outdoor-table';
  if (has('outdoor') || has('patio')) {
    if (has('umbrella') || has('cantilever')) return 'umbrella';
    if (has('table') || has('island')) return 'outdoor-table';
    return 'outdoor-seating';
  }
  for (const g of rules.split(';')) {
    const [cat, keys] = g.split('=');
    if (!keys) continue;
    for (const k of keys.split('|')) if (has(k)) return cat;
  }
  return 'other';
}

class KdRelatedBrand extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    this.dataset.loaded = '1';
    const run = () => this.load().catch(() => {});
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 });
    else setTimeout(run, 300);
  }

  async load() {
    const vendor = this.dataset.vendor || '';
    if (!vendor) return;
    const exclude = String(this.dataset.exclude || '');
    const limit = Number(this.dataset.limit || 8);
    const params = new URLSearchParams();
    params.set('q', vendor);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '10');
    params.set('resources[options][fields]', 'vendor');
    params.set('resources[options][unavailable_products]', 'hide');
    const root = (window.Theme && Theme.routes && Theme.routes.predictive_search_url) || '/search/suggest';
    const res = await fetch(root + '.json?' + params.toString(), { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const data = await res.json();
    const all = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    const norm = (s) => String(s || '').trim().toLowerCase();
    const cat = this.dataset.cat || '';
    const rules = this.dataset.rules || '';
    const same = (p) => cat && rules && classify(p.title, rules) === cat;
    const pool = all.filter((p) => p.available !== false && String(p.id) !== exclude && norm(p.vendor) === norm(vendor));
    // Same-category pieces (another bed on a bed page) go last, not out.
    const items = pool.filter((p) => !same(p)).concat(pool.filter(same)).slice(0, limit);
    if (items.length < 2) return;
    const host = this.querySelector('[data-kd-related-brand-cards]');
    if (!host) return;
    host.innerHTML = items.map((p) => this.card(p)).join('');
    this.hidden = false;
  }

  money(v) {
    const n = Math.floor(Number(v) || 0);
    return '$' + n.toLocaleString('en-US');
  }

  card(p) {
    const price = Number(p.price);
    const cmp = Number(p.compare_at_price_max || p.compare_at_price || 0);
    const onSale = cmp > price;
    const pct = onSale ? Math.round(((cmp - price) / cmp) * 100) : 0;
    const img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
    const src = img ? img.replace(/(\.[a-z]+)(\?.*)?$/i, '_480x$1$2') : '';
    const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    return (
      '<a class="kd-rcard" href="' + esc(p.url) + '">' +
      '<div class="kd-rcard__media">' +
      (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      (onSale && pct > 0 ? '<span class="kd-rcard__save">' + pct + '% off</span>' : '') +
      '</div>' +
      (p.vendor ? '<span class="kd-rcard__brand">' + esc(p.vendor) + '</span>' : '') +
      '<p class="kd-rcard__title">' + esc(p.title) + '</p>' +
      '<div class="kd-rcard__price"><span class="now">' + this.money(price) + '</span>' +
      (onSale ? '<span class="was">' + this.money(cmp) + '</span>' : '') +
      '</div></a>'
    );
  }
}

if (!customElements.get('kd-related-brand')) {
  customElements.define('kd-related-brand', KdRelatedBrand);
}
